/** Typical EFEM islands have 2 load ports; 3–4 is uncommon. */
export const MAX_EFEM_LOAD_PORTS = 4;
